import React from "react";

// All pages that rely on 3rd party components (other than Bootstrap) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";

//Guards
import AuthGuard from "./components/guards/AuthGuard";

//CRM
import Subaccounts from "./pages/crm/Subaccounts";
import Customers from "./pages/crm/Customers";
import Tenants from "./pages/crm/Tenants";
import Managers from "./pages/crm/Managers";
import Admins from "./pages/crm/Admins";

//Orders
import Orders from "./pages/pages/orders/Orders";

//Reports
import ReportsPage from "./pages/pages/reports/ReportsPage";

//Support
import SupportPage from "./pages/pages/support/SupportPage";

//Watchdog Alerts
import AlertsPage from "./pages/pages/alerts/AlertsPage";

//SIMs
import Sims from "./pages/pages/sims/Sims";
import SimProfile from "./pages/pages/sims/profile/SimProfile";

// Pages
import Profile from "./pages/pages/Profile";
import Settings from "./pages/pages/settings/Settings";
import Clients from "./pages/crm/Clients";
import Invoice from "./pages/pages/Invoice";
import Tasks from "./pages/pages/Tasks";
import Chat from "./pages/pages/Chat";

// Auth
import Page500 from "./pages/auth/Page500";
import Page404 from "./pages/auth/Page404";
import Page401 from "./pages/auth/Page401";
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import ResetPassword from "./pages/auth/ResetPassword";

// Protected routes
//import ProtectedPage from "./pages/protected/ProtectedPage";
import MainDashboard from "./pages/pages/dashboard/mainDashboard";
import BillingProducts from "./pages/billingproducts/BillingProducts";
import Offers from "./pages/offers/Offers";
import Invoices from "./pages/invoices/Invoices";
import Statements from "./pages/statements/Statements";
import VerifyMfaPage from "./pages/auth/VerifyMfa";
import Landing from "./layouts/Landing";
import SuccessPage from "./pages/pages/stripe/SuccessPage";
import ErrorPage from "./pages/pages/stripe/ErrorPage";
import Privileges from "./pages/privileges/Privileges";
import Emails from "./pages/emails/Emails";
import InitialPassword from "./components/auth/InitialPassword";
import Notifications from "./pages/notifications/Notifications";
import AutomatedReports from "./pages/pages/reports/automated/AutomatedReports";
import ReportsHistory from "./pages/pages/reports/history/ReportsHistory";
import OfferItems from "./pages/offers/OfferItems";
import Services from "./pages/pages/services/Services";
import WhitelistIP from "./pages/whitelist/WhitelistIP";
import CustomFields from "./pages/customFields/CustomFields";
import SimProducts from "./pages/pages/sim-products/SimProducts";
import PurchaseOrders from "./pages/purchaseOrders/PurchaseOrders";
import AssignSimProducts from "./pages/pages/sim-products/AssignSimProducts";
import InvalidToken from "./pages/auth/InvalidToken";
import HealthDashboard from "./pages/health/HealthDashboard";
import Doc from "./layouts/Doc";
import Introduction from "./pages/documentation/Introduction";
import DashboardDocs from "./pages/documentation/Dashboard";
import SimsIntroduction from "./pages/documentation/SimsIntroduction";
import SimsLifecycle from "./pages/documentation/SimsLifecycle";
import SimsPanel from "./pages/documentation/SimsPanel";
import SimProvisioning from "./pages/documentation/SimProvisioning";
import SimProfileDocs from "./pages/documentation/SimProfile";
import SimTransfers from "./pages/documentation/SimTransfers";
import WatchdogIntro from "./pages/documentation/WatchdogIntro";
import AddWatchdog from "./pages/documentation/AddWatchdog";
import RemoveWatchdogs from "./pages/documentation/RemoveWatchdogs";
import ResetWatchdog from "./pages/documentation/ResetWatchdog";
import BlockSuspension from "./pages/documentation/BlockSuspension";
import Alerts from "./pages/documentation/Alerts";
import ReportsIntro from "./pages/documentation/ReportsIntro";
import SingleReport from "./pages/documentation/SingleReport";
import AutomatedReportsDocs from "./pages/documentation/AutomatedReports";
import ReportsHistoryDocs from "./pages/documentation/ReportsHistory";
import API from "./pages/api/API";
import PurchaseOrdersHistory from "./pages/purchaseOrders/PurchaseOrdersHistory";
import Webhooks from "./pages/webhooks/Webhooks";
import TermsAndConditions from "./pages/documentation/TermsAndConditions";
import PrivacyPolicy from "./pages/documentation/PrivacyPolicy";

//import Main from "./components/Main";

const routes = [
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <SignIn />,
      },
      {
        path: "2fa",
        element: <VerifyMfaPage />,
      },
    ],
  },
  {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "default",
        element: <MainDashboard />,
      },
    ],
  },
  {
    path: "/demo",
    element: <DashboardLayout demoMode={true} />,
    children: [
      {
        path: "",
        element: <MainDashboard demoMode={true} />,
      },
      {
        path: "sims",
        element: <Sims demoMode={true} />,
      },
      {
        path: "account/profile",
        element: <Profile demoMode={true} />,
      },
      {
        path: "account/orders",
        element: <Orders demoMode={true} />,
      },
      {
        path: "reports/single",
        element: <ReportsPage demoMode={true} />,
      },
      {
        path: "reports/automated",
        element: <AutomatedReports demoMode={true} />,
      },
      {
        path: "reports/history",
        element: <ReportsHistory demoMode={true} />,
      },
      {
        path: "alerts",
        element: <AlertsPage demoMode={true} />,
      },
      {
        path: "account/invoices",
        element: <Invoice demoMode={true} />,
      },
      {
        path: "account/statements",
        element: <Statements demoMode={true} />,
      },
      {
        path: "account/emails",
        element: <Emails demoMode={true} />,
      },
      {
        path: "account/whitelist",
        element: <WhitelistIP demoMode={true} />,
      },
      {
        path: "account/billingProducts",
        element: <BillingProducts demoMode={true} />,
      },
      {
        path: "account/customFields",
        element: <CustomFields demoMode={true} />,
      },
      {
        path: "notification",
        element: <Notifications demoMode={true} />,
      },
      {
        path: "settings",
        element: <Settings demoMode={true} />,
      },
    ],
  },
  {
    path: "docs",
    element: <Doc />,
    children: [
      {
        path: "introduction",
        element: <Introduction />,
      },
      {
        path: "dashboard",
        element: <DashboardDocs />,
      },
      {
        path: "sims/introduction",
        element: <SimsIntroduction />,
      },
      {
        path: "sims/lifecycle",
        element: <SimsLifecycle />,
      },
      {
        path: "sims/panel",
        element: <SimsPanel />,
      },
      {
        path: "sims/provisioning",
        element: <SimProvisioning />,
      },
      {
        path: "sims/profile",
        element: <SimProfileDocs />,
      },
      {
        path: "sims/transfer",
        element: <SimTransfers />,
      },
      {
        path: "watchdog/introduction",
        element: <WatchdogIntro />,
      },
      {
        path: "watchdog/add",
        element: <AddWatchdog />,
      },
      {
        path: "watchdog/remove",
        element: <RemoveWatchdogs />,
      },
      {
        path: "watchdog/reset",
        element: <ResetWatchdog />,
      },
      {
        path: "watchdog/block-suspension",
        element: <BlockSuspension />,
      },
      {
        path: "watchdog/alerts",
        element: <Alerts />,
      },
      {
        path: "reports/introduction",
        element: <ReportsIntro />,
      },
      {
        path: "reports/single",
        element: <SingleReport />,
      },
      {
        path: "reports/automated",
        element: <AutomatedReportsDocs />,
      },
      {
        path: "reports/history",
        element: <ReportsHistoryDocs />,
      },
      {
        path: "api",
        element: <API />,
      },
      {
        path: "terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
  {
    path: "sims",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Sims />,
      },
      {
        path: "profile/:imsi",
        element: <SimProfile />,
      },
      {
        path: "purchase",
        element: <PurchaseOrders />,
      },
    ],
  },
  {
    path: "account",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "billingproducts",
        element: <BillingProducts />,
      },
      {
        path: "invoices",
        element: <Invoices />,
      },
      {
        path: "statements",
        element: <Statements />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
      {
        path: "emails",
        element: <Emails />,
      },
      {
        path: "whitelist",
        element: <WhitelistIP />,
      },
      {
        path: "customFields",
        element: <CustomFields />,
      },
      {
        path: "purchase-orders",
        element: <PurchaseOrdersHistory />,
      },
      {
        path: "webhooks",
        element: <Webhooks />,
      },
    ],
  },
  {
    path: "crm",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "users",
        element: <Subaccounts />,
      },
      {
        path: "customers",
        element: <Customers />,
      },
      {
        path: "tenants",
        element: <Tenants />,
      },
      {
        path: "managers",
        element: <Managers />,
      },
      {
        path: "admins",
        element: <Admins />,
      },
    ],
  },
  {
    path: "account",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "billingproducts",
        element: <BillingProducts />,
      },
    ],
  },
  {
    path: "catalogue",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "offers",
        element: <Offers />,
      },
      {
        path: "offer-items",
        element: <OfferItems />,
      },
      {
        path: "sim-products",
        element: <AssignSimProducts />,
      },
    ],
  },
  {
    path: "reports",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "single",
        element: <ReportsPage />,
      },
      {
        path: "automated",
        element: <AutomatedReports />,
      },
      {
        path: "history",
        element: <ReportsHistory />,
      },
    ],
  },
  {
    path: "alerts",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <AlertsPage />,
      },
    ],
  },
  {
    path: "notifications",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Notifications />,
      },
    ],
  },
  {
    path: "support",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <SupportPage />,
      },
    ],
  },
  {
    path: "pages",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "privileges",
        element: <Privileges />,
      },
      {
        path: "clients",
        element: <Clients />,
      },
      {
        path: "invoice",
        element: <Invoice />,
      },
      {
        path: "tasks",
        element: <Tasks />,
      },
      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "sim-products",
        element: <SimProducts />,
      },
      {
        path: "health",
        element: <HealthDashboard />,
      },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-up/:token",
        element: <SignUp />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "401",
        element: <Page401 />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
      {
        path: "500",
        element: <Page500 />,
      },
      {
        path: "change-password/:token",
        element: <InitialPassword />,
      },
      {
        path: "invalid-token",
        element: <InvalidToken />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <MainDashboard />,
      },
    ],
  },
  {
    path: "/profile",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Profile />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
  {
    path: "stripe",
    element: <Landing />,
    children: [
      {
        path: "success",
        element: <SuccessPage />,
      },
      {
        path: "error",
        element: <ErrorPage />,
      },
    ],
  },
];

export default routes;
